import React, { ReactNode, useState } from 'react'
import { Outlet, useNavigation } from 'react-router-dom'
import { useLingui } from '@lingui/react'
import LoadingOverlay from '../LoadingOverlay/LoadingOverlay'
import Header from '../Header/Header'
import styles from './PageLayout.module.css'

export interface PageLayoutContext {
    setBeforeContent: (content: ReactNode) => void
}

const PageLayout = () => {
    const { i18n } = useLingui()

    const navigation = useNavigation()

    const [beforeContent, setBeforeContent] = useState<ReactNode>(null)

    if (navigation.state === 'loading') {
        return <LoadingOverlay />
    }

    const context: PageLayoutContext = {
        setBeforeContent,
    }

    return (
        <div className={styles.container}>
            <div className={styles.card}>
                <Header />

                {beforeContent}

                <div className={styles.content}>
                    <Outlet key={i18n.locale} context={context} />
                </div>
            </div>
        </div>
    )
}

export default PageLayout
